import React from "react";
import { ProductPriceVariant } from "src/features/products/components/ProductPrice";
import projectOptions from "../project-options";
import { SpanDiscount } from "../style/Discount.style";
import { SpanDiscountPlaceholder } from "../style/DiscountPlaceholder.style";

type Props = {
  productDiscount: string;
  showMinus?: boolean;
  variant?: ProductPriceVariant;
};

const Discount = ({ productDiscount, showMinus, variant }: Props) => {
  const { showDiscount } = projectOptions.default.style.product;
  if (!showDiscount || !productDiscount || productDiscount === "%100")
    return <SpanDiscountPlaceholder className="akn-discount-placeholder" />;

  return (
    <SpanDiscount className="akn-product-discount" $variant={variant}>
      {showMinus && "- "}
      {productDiscount}
    </SpanDiscount>
  );
};

export default Discount;
